import type { RouterConfig } from "@nuxt/schema";
import { AdminPermission } from "~~/schemas/admin-role";

export default <RouterConfig>{
  routes: () => [
    {
      name: "login",
      path: "/login",
      component: () => import("~/views/auth/login/Login.vue"),
      meta: { authRequired: false, layout: "blank" },
    },

    {
      name: "forbidden",
      path: "/403",
      component: () => import("~/views/error/Forbidden.vue"),
      meta: { layout: "blank" },
    },

    {
      name: "home",
      path: "/",
      component: () => import("~/views/home/Home.vue"),
      meta: { requiredPermission: AdminPermission.AnalyticsRead },
    },

    {
      name: "workspace-list",
      path: "/workspace",
      component: () => import("~/views/workspace/Workspace.vue"),
      meta: { requiredPermission: AdminPermission.WorkspacesRead },
    },
    {
      name: "workspace-detail",
      path: "/workspace/:id",
      component: () => import("~/views/workspace/WorkspaceDetail.vue"),
      meta: { requiredPermission: AdminPermission.WorkspacesRead },
    },

    {
      name: "workspace-plan-list",
      path: "/workspace-plan",
      component: () => import("~/views/workspace-plan/WorkspacePlan.vue"),
      meta: { requiredPermission: AdminPermission.WorkspacePlansRead },
    },

    {
      name: "app-list",
      path: "/apps",
      component: () => import("~/views/app/App.vue"),
      meta: { requiredPermission: AdminPermission.AppsRead },
    },

    {
      name: "lead-list",
      path: "/leads",
      component: () => import("~/views/lead/Lead.vue"),
      meta: { requiredPermission: AdminPermission.LeadsRead },
    },
    {
      name: "lead-detail",
      path: "/leads/:id",
      component: () => import("~/views/lead/LeadDetail.vue"),
      meta: { requiredPermission: AdminPermission.LeadsRead },
    },

    {
      name: "analytics-workspaces",
      path: "/analytics/workspaces",
      component: () => import("~/views/analytics/WorkspaceReport.vue"),
      meta: { requiredPermission: AdminPermission.AnalyticsRead },
    },
    {
      name: "analytics-usage",
      path: "/analytics/usage",
      component: () => import("~/views/analytics/ProductUsageReport.vue"),
      meta: { requiredPermission: AdminPermission.AnalyticsRead },
    },

    {
      name: "finance-reports",
      path: "/finance/reports",
      component: () => import("~/views/finance/FinanceReport.vue"),
      meta: { requiredPermission: AdminPermission.AnalyticsRead },
    },
    {
      name: "finance-costs",
      path: "/finance/costs",
      component: () => import("~/views/finance/CostEntry.vue"),
      meta: { requiredPermission: AdminPermission.CostsRead },
    },

    {
      name: "order-list",
      path: "/order",
      component: () => import("~/views/order/Order.vue"),
      meta: { requiredPermission: AdminPermission.OrdersRead },
    },
    {
      path: "/workspace-orders",
      component: () => import("~/views/workspace-order/WorkspaceOrder.vue"),
      meta: { requiredPermission: AdminPermission.WorkspaceOrdersRead },
    },

    {
      name: "admin-user-list",
      path: "/administrators",
      component: () => import("~/views/admin-user/AdminUser.vue"),
      meta: { requiredPermission: AdminPermission.AdminUsersRead },
    },
    {
      name: "admin-role-list",
      path: "/roles",
      component: () => import("~/views/admin-role/AdminRole.vue"),
      meta: { requiredPermission: AdminPermission.AdminRolesRead },
    },

    {
      name: "site-template-list",
      path: "/site-template",
      component: () => import("~/views/site-template/SiteTemplate.vue"),
      meta: { requiredPermission: AdminPermission.SiteTemplatesRead },
    },
    {
      name: "site-template-builder",
      path: "/site-template/:id/builder",
      component: () => import("~/views/site-template/SiteTemplateEditor.vue"),
      meta: { layout: "blank", requiredPermission: AdminPermission.SiteTemplatesWrite },
    },

    {
      name: "global-asset-list",
      path: "/global-asset",
      component: () => import("~/views/global-asset/GlobalAsset.vue"),
    },

    {
      name: "profile",
      path: "/profile",
      component: () => import("~/views/profile/Profile.vue"),
    },

  ],
};
